<div class="file-field">
    <div class="d-flex justify-content-center flex-column align-items-center">
        <div class="icon-container mb-2"> 
            <img src="/images/svg/upload-cloud-02.svg" style="height: 20px; width: 20px;" alt="Upload">
        </div>
        <div class="d-flex flex-row align-items-center text-styles">
            <div class="mr-2" [ngClass]="getClassList()">
                <span class="text-purple"><b>Click to upload</b></span>
                <input *ngIf="multiple" #field (change)="onChange($event)" (click)="onClick()" type="file" [accept]="accept" [disabled]="disabled" multiple />
                <input *ngIf="!multiple" #field (change)="onChange($event)" (click)="onClick()" type="file" [accept]="accept" [disabled]="disabled" />
            </div>
            <span>or drag and drop</span>
        </div>
        <div class="d-inline-flex">
            SVG, PNG, JPG or GIF 
            @if (size.h != 0 && size.w != 0) {
                (max. {{size.w}} x {{size.h}}px)
            }
        </div>
    </div>
</div>